import { CommonSectionTitle } from "@Components/common-section-title/CommonSectionTitle";
import CustomizedAccordion from "./CustomizedAccordion";

interface IPropsFaqSection {
  data: any; // using any until we have the proper data structure
}
export default function FaqSection({ data }: IPropsFaqSection) {
  const { title, icon, faqItems } = data;
  return (
    <>
      <CommonSectionTitle
        id={title?.replace?.(" ", "_")}
        title={title}
        icon={icon}
      />
      {faqItems?.items?.map((faq: any, index: number) => (
        <CustomizedAccordion
          key={`${title}_${index}`}
          id={index + 1}
          data={faq}
        />
      ))}
    </>
  );
}
